import React, { useEffect, useState } from "react";
import { fileUrl } from "../../../../services/config";
import { useLocation } from "react-router";
import Button from "../../../../components/common/button/Button";
import {
  successMessage,
  warningMessage,
} from "../../../../utils/toastify-message/ToastifyMessage";
import ProductModal from "../../../../components/common/modals/product-modal/ProductModal";

const { forwardRef, useRef, useImperativeHandle } = React;

const FreeGteThanPrice = forwardRef(({ handleFreeGteThanPrice }, ref) => {
  const location = useLocation();

  const [showModal, setShowModal] = useState(false);
  const [price, setPrice] = useState(0);

  useImperativeHandle(ref, () => ({
    showModal() {
      setShowModal(!showModal);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    afterSubmit() {},
  }));

  const productModalRef = useRef();

  const [products, setProducts] = useState([]);

  const handleProduct = (data) => {
    const isExist = products.filter((item) => {
      return item._id == data._id;
    });
    if (isExist.length) {
      warningMessage("این کالا از قبل وجود دارد");
    } else {
      setProducts((prev) => [...prev, data]);
      successMessage("محصول با موفقیت اضافه شد");
    }
  };

  const handle = () => {
    const neProducts = products.map((item) => {
      return item._id;
    });
    if (!price.length && neProducts.length) {
      warningMessage("قیمت را انتخاب کنید.");
    } else if (price.length) {
      handleFreeGteThanPrice({
        value: Number(price),
        neProducts: neProducts,
      });
      setShowModal(!showModal);
    } else {
      handleFreeGteThanPrice(null);
      setShowModal(!showModal);
    }
  };

  useEffect(() => {
    if (location?.state?.freeGteThanPrice) {
      setPrice(location?.state?.freeGteThanPrice);
    }
    if (location?.state?.freeGteThanPriceNe) {
      setProducts(location?.state?.freeGteThanPriceNe);
    }
  }, [location.state]);

  const deleteProduct = (data) => {
    const newProduct = products.filter((item) => {
      return data._id !== item._id;
    });
    setProducts(newProduct);
  };

  useEffect(() => {
    if (location.pathname == "/add-product-shipping") {
      setPrice("");
      setProducts([]);
    }
  }, [location.pathname]);

  return (
    <>
      <div
        className={`fixed top-0 right-0 w-full h-full transition-all z-30  ${
          !showModal && "hidden"
        }`}
      ></div>
      <div
        className={`w-full h-full overflow-y-scroll  bg-white dark:bg-gray-900 shadow-md z-40 rounded-3xl p-4 transition-all absolute top-0 -left-[120%] ${
          showModal && "!left-0"
        }`}
      >
        <div className="flex items-center justify-between dark:text-white">
          <h4>رایگان برای قیمت</h4>
          <Button
            text={"بازگشت"}
            type="button"
            color="primary"
            onClick={handle}
          />
        </div>
        <div className="flex justify-between items-center w-full">
          <div className="flex my-4 max-w-6/12">
            <input
              type="text"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="قیمت"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />
          </div>
          <Button
            text={"افزودن کالا"}
            type="button"
            color="success"
            onClick={() => productModalRef.current.showModal()}
          />
        </div>
        <h4 className="mt-4 dark:text-white">لیست کالا به غیر اینا</h4>
        {products.length ? (
          <div className="relative overflow-x-auto shadow-md sm:rounded-lg mt-6">
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" className="px-16 py-3">
                    <span className="sr-only">عکس</span>
                  </th>
                  <th scope="col" className="px-6 py-3">
                    کالا
                  </th>
                  <th scope="col" className="px-6 py-3">
                    عملیات
                  </th>
                </tr>
              </thead>
              <tbody>
                {products.map((item, index) => {
                  return (
                    <tr
                      key={index}
                      className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                    >
                      <td className="p-2">
                        <img
                          src={
                            item.mainImage
                              ? `${fileUrl}files/medium_${item.mainImage}`
                              : require("./../../../../assets/images/userIcon.png")
                          }
                          className="w-16 h-16 max-w-full max-h-full rounded-xl"
                          alt="Apple Watch"
                        />
                      </td>
                      <td className="px-6 py-4 font-semibold text-gray-900 dark:text-white">
                        {item.name}
                      </td>
                      <td className="px-6 py-4">
                        <button
                          onClick={() => deleteProduct(item)}
                          className="font-medium text-red-600 dark:text-red-500 hover:underline"
                        >
                          حذف
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="w-full flex justify-center shadow rounded-xl py-3 my-3 dark:text-white">
            <p>شما هنوز هیچ محصولی را انتخاب نکرده اید</p>
          </div>
        )}
      </div>
      <ProductModal ref={productModalRef} handleProduct={handleProduct} />
    </>
  );
});
export default FreeGteThanPrice;
